<ui-bottom-sheet-shell
    title="Dettaglio nota"
    (close)="onClose()"
>
    <div bottom-sheet-content class="note-bottom-sheet-card">
        <span class="body-small">{{ note.data | date:'dd/MM/yyyy HH:mm' }}</span>
        <span class="body-medium-emphasized">{{ note.titolo }}</span>
        <span class="body-small">{{ note.testo }}</span>
    </div>

    <div bottom-sheet-footer>
        <button matButton="filled" type="button" (click)="onEdit()">Modifica</button>
        <button matButton type="button" (click)="onClose()">Annulla</button>
    </div>
</ui-bottom-sheet-shell>
